import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StoreKeys } from '../../models/store-keys';
import { CurrentSupervisionState } from './reducer/current-supervision.reducer';


export const selectCurrentSupervisionFeature = createFeatureSelector<CurrentSupervisionState>(StoreKeys.CURRENT_SUPERVISION);

export const selectCurrentSupervisionDatasCurrentWkfSupervisionParams = createSelector(selectCurrentSupervisionFeature, state => state.datas?.currentWkfSupervisionParams);